import React, { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import NewBaseListItem from './base-list-item';
import EntityTypeIcon from '@icons/entity-type-icon';
import { getConfigValue } from '@utils/list-item-utils';
import './list-item.scss';

const NewEntityListItem = ({ entity_type, id, segments, type_name, onClick, customOnClick, ...otherProps }) => {
  const handleClick = useCallback(() => {
    if (customOnClick) {
      customOnClick();
    } else if (onClick) {
      onClick('entity', id, segments);
    }
  }, [customOnClick, id, onClick, segments]);

  const renderType = useCallback(() => {
    const typeRowValue = getConfigValue(type_name, 'type-row', { type_name, ...otherProps });
    if (typeRowValue) {
      return (
        <div styleName="footer-type">
          <span>&nbsp;&nbsp;&bull;&nbsp;&nbsp;</span>
          <span>{typeRowValue}</span>
        </div>
      );
    }
    return null;
  }, [type_name, otherProps]);

  const renderTypeIcon = useCallback(() => (
    <div styleName="icon type-icon">
      <EntityTypeIcon type={entity_type} />
    </div>
  ), [entity_type]);

  return (
    <NewBaseListItem
      {...otherProps}
      id={id}
      type_name={type_name}
      entityTypeName="entity"
      onClick={handleClick}
      renderType={renderType}
      renderTypeIcon={renderTypeIcon}
    />
  );
};

NewEntityListItem.propTypes = {
  customOnClick: PropTypes.func,
  entity_type: PropTypes.string,
  id: PropTypes.number,
  onClick: PropTypes.func,
  segments: PropTypes.array,
  type_name: PropTypes.string
};

export default memo(NewEntityListItem);
